module.exports = __webpack_public_path__ + "static/img/third2_1_8.27d3e364.jpg";